import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../store/structureDefinitions/cartState';

const selectProfile = (state: RootState) => state.user.profile;
const selectDebug = (state: RootState) => state.ui.debug;

const selectFirstName = createSelector(selectProfile, (state) => state?.firstName);
const selectIsShoppingForAnother = createSelector(
    selectProfile,
    (state) => state?.isShoppingForAnother,
);
const selectLastName = createSelector(selectProfile, (state) => state?.lastName);
const selectIsAuthenticated = createSelector(selectProfile, (state) => !!state?.isAuthenticated);
const selectIsAuthenticatedBankId = createSelector(
    selectProfile,
    (state) => !!state?.isAuthenticatedWithBankId,
);
const selectIsCompany = createSelector(selectProfile, (state) => !!state?.isCompany);
const selectIsMember = createSelector(
    selectProfile,
    selectDebug,
    (state, debug) => !!state?.medmeraId || debug.mockUserIsMember,
);
const selectHasKimCustomerId = createSelector(selectProfile, (state) => !!state?.hasKimCustomerId);
const selectShoppingUserId = createSelector(selectProfile, (state) => state?.shoppingUserId);
const selectIsBetaTester = createSelector(selectProfile, (state) => state?.isBetaTester);
const selectUserId = createSelector(selectProfile, (state) => state?.id);
const selectIsEpiUser = createSelector(selectProfile, (state) => state?.isEpiUser);

const selectFullName = createSelector(selectFirstName, selectLastName, (first, last) => {
    if (!first || !last) {
        return undefined;
    }
    return `${first} ${last}`;
});

const selectInitials = createSelector(selectFirstName, selectLastName, (first, last) => {
    if (!first || !last) {
        return undefined;
    }

    return `${first.charAt(0)}${last.charAt(0)}`;
});

export const userProfileSelectors = {
    profile: selectProfile,
    fullName: selectFullName,
    initials: selectInitials,
    isAuthenticated: selectIsAuthenticated,
    isAuthenticatedWithBankId: selectIsAuthenticatedBankId,
    isMember: selectIsMember,
    isCompany: selectIsCompany,
    hasKimCustomerId: selectHasKimCustomerId,
    shoppingUserId: selectShoppingUserId,
    isBetaTester: selectIsBetaTester,
    id: selectUserId,
    isEpiUser: selectIsEpiUser,
    isShoppingForAnother: selectIsShoppingForAnother,
};
